import { ScaleType } from '../../../learnware/LearnwareEnums';
import { round } from '../../../../utils/helper/lodash_replacements';
import { configTrait } from '../../../../registry/trait/ConfigTrait';
export class AttachedScaledValue {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get at() {
        return this.parent;
    }
    get trait() {
        return this.at.trait;
    }
    get aspect() {
        return this.at.parent;
    }
    get stage() {
        return this.at.context.stage;
    }
    get scaleType() {
        const defaultScaling = configTrait.scaleDefaultConfig[this.at.key];
        const localScaling = this.at.trait.local.valueOf[`scale_${this.at.key}`];
        if (localScaling !== defaultScaling)
            return localScaling;
        const stageScaling = this.stage.ownAspect.scaling.valueOf[`scale_${this.at.key}`];
        if (stageScaling !== defaultScaling)
            return stageScaling;
        return defaultScaling;
    }
    get scaledValueExact() {
        const value = this.at.attachedValue;
        if (!configTrait.scaleProperties.includes(this.at.key) || typeof value !== 'number') {
            return value;
        }
        if (this.scaleType === ScaleType.Width) {
            return value * this.stage.stageInnerMeasure.stageWidthRatio;
        }
        if (this.scaleType === ScaleType.Height) {
            return value * this.stage.stageInnerMeasure.stageHeightRatio;
        }
        if (this.scaleType === ScaleType.Ratio) {
            return value * this.stage.stageInnerMeasure.stageDiagonalRatio;
        }
        return value;
    }
    // @computed
    get scaledValue() {
        if (typeof this.at.reg.roundDecimals !== 'undefined') {
            return round(this.scaledValueExact, this.at.reg.roundDecimals);
        }
        return this.scaledValueExact;
    }
    set scaledValue(scaledValue) {
        let value = scaledValue;
        if (this.scaleType === ScaleType.Width) {
            value = value / this.stage.stageInnerMeasure.stageWidthRatio;
        }
        if (this.scaleType === ScaleType.Height) {
            value = value / this.stage.stageInnerMeasure.stageHeightRatio;
        }
        if (this.scaleType === ScaleType.Ratio) {
            value = value / this.stage.stageInnerMeasure.stageDiagonalRatio;
        }
        this.at.trait.value = round(value, this.at.reg.roundDecimals);
    }
}
